import { createContext, useState } from 'react';

export const PortalElementContext = createContext({
     stickyElement: null, setStickyElement: null,
});

export const useStickyElementContext = () => {
    const [stickyElement, setStickyElement] = useState();

    return {
        portalElementContext: { stickyElement, setStickyElement },
        PortalElementContextProvider: PortalElementContext.Provider,
    };
};

